import * as api from "../api/verificationApi";
import * as types from "../constants/ActionTypes";

import { FormattedMessage } from "react-intl";
import React from "react";
import { showNotification } from "./notificationsActions";

export const verify = ({
  email,
  otpCode,
  accountId,
  type
}) => async dispatch => {
  try {
    const resp_json = await api.verify({
      email, 
      otpCode,
      accountId,
      type
    }); 
    if (resp_json) {
      //success, redirect to portal
      dispatch(verificationSucceeded(resp_json.url, type));
    }
    else{
      dispatch(verificationFailed(type));
    }
  } catch (err) {
    const response = err.response && (await err.response.json());
    const errorMessages = (response && response.errors) || [
      <FormattedMessage
        id="genericError"
        defaultMessage="An unexpected error occurred and our engineering team has been notified. Please try again in a few moments."
      />
    ];
    for (let message of errorMessages) {
      dispatch(
        showNotification({
          message,
          notificationType: "error",
          dismissDelay: 3000
        })
      );
    }
  }
};

const verificationSucceeded = (url, type) => ({
  type: types.VERIFICATION_SUCCEEDED,
  verification_type: type,
  url: url 
});

const verificationFailed = (type) => ({
  type: types.VERIFICATION_FAILED,
  verification_type: type
});